$(function(){
  var w = window.innerWidth ? window.innerWidth: $(window).width();
  if ( w < 769 ) {
    $('a.m-productlink').addClass('btn btn-gold hvr-rectangle-in');
  } else {
    $('a.m-productlink').removeClass('btn btn-gold hvr-rectangle-in');
  }
});
